import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../common-services/user.services';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {
  constructor(private router: Router, private userService: UserService) {}

  /**
   * Check if the user is logged in before calling http
   *
   * @param route
   * @param state
   * @returns {boolean}
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Check if the user is logged in
    if (this.userService.isLoggedIn()) {
      const userCredentials = this.userService.currentUserCredantials;

      // Check if the user's ID is expired
      if (userCredentials.isIdExpired) {
        this.router.navigate(['/authentication/id-expired']);
        return false;
      }

      // Check if the user's account is suspended
      if (userCredentials.isSuspended) {
        this.router.navigate(['/authentication/id-suspended']);
        return false;
      }

      // If no conditions are met, allow navigation
      return true;
    }

    // If not logged in, redirect to the login page
    this.router.navigate(['/authentication/login']);
    return false;
  }
}
